<template>
  <div class="flex flex-col">
    <!--    <div v-show="scrollPosition > 110" slot="header"-->
    <!--         class="z-50 flex justify-center fixed top-0 left-0 pt-20 pb-3 font-bold text-gray-900 bg-white border-b w-full">-->
    <!--      <div class="max-w-a10 w-full px-5">-->
    <!--        {{ category.name }}-->
    <!--      </div>-->
    <!--    </div>-->
    <inertia-link :href="route('shop.landing-home')" :data="{ anchor: 'categories' }"
                  class="flex self-start items-center font-bold mb-8 text-gray-700 hover:text-gray-900 transition ease-in-out duration-150">
      <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
           viewBox="0 0 24 24" stroke="currentColor">
        <path d="M15 19l-7-7 7-7"></path>
      </svg>
      <span>{{ $t('menu.categories') }}</span>
    </inertia-link>
    <div class="flex md:flex-row flex-col-reverse mb-12">
      <h1 class="text-gray-900 text-2xl lg:text-3xl font-medium w-full md:w-1/2">
        {{ category.name }}
      </h1>
      <div class="w-full md:1/2 mb-2 md:mb-0">
        <img :src="category.image" class="float-right"/>
      </div>
    </div>
    <div v-if="category.id == 101" class="flex flex-wrap mb-8 justify-start">
      <div class="w-full md:w-1/4">
        <select-input v-model="lotFilter" :a10="true" class="mr-8"
                      v-bind:label="$t('lot.filter_by')">
          <option value="allPrice">{{ $t('gift.all') }}</option>
          <option value="2">Preț descendent</option>
          <option value="3">Preț ascendent</option>
        </select-input>
      </div>
      <div class="w-full md:w-1/4">
        <select-input id="gift-categories" @input="getSubcategories" :a10="true" class="mr-8"
                      v-bind:label="$t('lot.gift_filter_by')" ref="gift-categories">
          <option value="allGifts">{{ $t('gift.all') }}</option>
          <option value="11">{{ $t('gift.her') }}</option>
          <option value="12">{{ $t('gift.him') }}</option>
          <option value="13">{{ $t('gift.wedding') }}</option>
          <option value="14">{{ $t('gift.home') }}</option>
          <option value="15">{{ $t('gift.business') }}</option>
        </select-input>
      </div>
      <div class="w-full md:w-1/4">
        <select-input :value="perPage ? perPage : 9" @input="changeLotsPerPage" :a10="true" class=" mr-8"
                      v-bind:label="$t('lot.per_page')" ref="lots-per-page">
          <option value="9">9</option>
          <option value="24">24</option>
          <option value="48">48</option>
          <option value="96">96</option>
          <option value="all">Toate</option>
        </select-input>
      </div>
      <div class="w-full md:w-1/4">
        <div class="flex flex-wrap">
          <div class="w-full md:w-2/3">
            <label style="color: #6c757d;" class="form-label">{{ $t('lot.range') }}</label>
            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 mr-3 a10-form-select">
                <input v-model="rangeMin"/>
              </div>
              <div class="w-full md:w-1/3 a10-form-select">
                <input v-model="rangeMax"/>
              </div>
            </div>
          </div>
          <div v-if="$isMobile()" class="w-full md:w-1/3" style="z-index: 999">
            <button class="btn-gray mt-3" style="width: 100%" @click="filterByPrice">{{ $t('misc.filter') }}</button>
          </div>
          <div v-else class="w-full md:w-1/3" style="z-index: 999">
            <button class="btn-gray mt-7 float-right" @click="filterByPrice">{{ $t('misc.filter') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-wrap mb-8 justify-start">
      <div class="w-full md:w-1/3">
        <select-input v-model="lotFilter" :a10="true" class="mr-8"
                      v-bind:label="$t('lot.filter_by')">
          <option value="allPrice">{{ $t('gift.all') }}</option>
          <option value="2">Preț descendent</option>
          <option value="3">Preț ascendent</option>
        </select-input>
      </div>
      <div class="w-full md:w-1/3">
        <select-input :value="perPage ? perPage : 9" @input="changeLotsPerPage" :a10="true" class=" mr-8"
                      v-bind:label="$t('lot.per_page')" ref="lots-per-page">
          <option value="9">9</option>
          <option value="24">24</option>
          <option value="48">48</option>
          <option value="96">96</option>
          <option value="all">Toate</option>
        </select-input>
      </div>
      <div class="w-full md:w-1/3">
        <div class="flex flex-wrap">
          <div class="w-full md:w-3/4">
            <label  style="color: #6c757d;" class="a10-form-label">{{ $t('lot.range') }}</label>
            <div class="flex flex-wrap">
              <div class="w-full md:w-1/3 mr-3 a10-form-select">
                <input v-model="rangeMin"/>
              </div>
              <div class="w-full md:w-1/3 a10-form-select">
                <input v-model="rangeMax"/>
              </div>
            </div>
          </div>
          <div v-if="$isMobile()" class="w-full md:w-1/4">
            <button class="btn-gray mt-3" style="width: 100%" @click="filterByPrice">{{ $t('misc.filter') }}</button>
          </div>
          <div v-else class="w-full md:w-1/4">
            <button class="btn-gray mt-7 float-right" @click="filterByPrice">{{ $t('misc.filter') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col  w-full mx-auto overflow-hidden px-4 mb-16" v-if="filteredLots.length">
      <div class="flex flex-wrap">
        <div v-for="(lot, index) in filteredLots" v-if="lot.slug" :key="index" class="p-5 w-full md:w-1/2 lg:w-1/3 group" style="position: relative; display: inline-block;">
          <inertia-link class="flex justify-center" :href="route('shop.lot.view', lot.slug)">
            <img class="transform group-hover:scale-105 transition ease-in-out duration-150"
                 :src="lot.auction_listing_image" :alt="`Image of ${lot.title}`"/>
            <div v-if="lot.shop_status === 2" class="top-left" style=" margin: 0px auto; text-align: center; width: 65px; background-color: black; height: 65px; line-height: 65px;   border-radius: 50%;   font-size: 14px;   color: rgb(255, 255, 255);   position: absolute;     top: 42%;
    left: 50%; transform: translate(-50%, -50%);">
              Sold
            </div>
          </inertia-link>

          <div class="pt-6 flex justify-between items-start">
            <inertia-link :href="route('shop.lot.view', lot.slug)"><h2
                class="a10-lot-listing-title pr-6 group-hover:text-black transition ease-in-out duration-150" v-html="makeLotTitle(lot, true)">
              </h2></inertia-link>
            <!--                    <button v-if="lot.shop_status == 0" @click="addToCart(lot.id)" class="btn-gray">{{$t('cart.add_cart')}}</button>-->
            <div :id="'addToCart_wrapper_' + lot.id">
              <button v-if="lot.shop_status == 0 && inArray(lot.id) == false" @click="addToCart(lot.id)"
                      class="btn-gray ">{{ $t('cart.add_cart') }}
              </button>
              <a :href="route('shop.cart.view')"
                 v-else-if="lot.shop_status == 0 && inArray(lot.id) == true"
                 class="btn-gray addToCartDisabled"><span v-html="$t('cart.added_cart_category')"></span></a>
            </div>
          </div>
          <div class="flex justify-between items-center pt-3">
            <div class="autorPret">
              <h4 class="a10-lot-listing-author">
                        <span v-for="(artist,index) in lot.artists" :key="index">
                            <span v-if="artist.firstname">{{ artist.firstname }} {{ artist.lastname }}</span><span
                            v-else>{{ artist.name }}</span><span v-if="index != lot.artists.length - 1">, </span>
                        </span>
                <div v-if="!lot.artists && lot.old_artist">
                  {{ lot.old_artist }}
                </div>
              </h4>
              <h4 v-if="lot.shop_status === 2" class="a10-lot-listing-price">
                {{ $t('cart.sold_for') }}: &euro; {{ lot.formatted_shop_price }}
              </h4>
              <h4 v-else-if="lot.shop_status !== 2" class="a10-lot-listing-price">
                  <span v-if="lot.custom_shop_price && lot.shop_price_first_discount"><s>{{$t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</s>
                  <br/>
                    <span v-if="lot.shop_price_first_discount" ><s>{{ $t('cart.discount_sell_price') }}: &euro; {{lot.shop_price_first_discount }}</s></span>
                    <br/>
                    <span style="color:darkred"><b>{{ $t('cart.custom_sell_price') }}: &euro; {{lot.custom_shop_price }}</b></span>
                  </span>
                <span v-else-if="lot.shop_discount_price">
                    <span><s>{{$t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</s></span>
                  <br/>
                    <span v-if="lot.shop_discount_price" style="color:darkred">{{ $t('cart.discount_sell_price') }}: &euro; {{lot.shop_discount_price }}</span>
                  </span>
                <span v-else>{{ $t('cart.sell_price') }}: &euro; {{ lot.formatted_shop_price }}</span>
              </h4>
            </div>
            <div class="favShare">
              <inertia-link v-if="lot.is_gift" :href="route('shop.category.view', 'gifts')"><img
                  src="/assets/img/icons/3-01.png" height="20" width="20"
                  style="display: inline; vertical-align: top;margin-right: 5px"/></inertia-link>
              <button v-if="lot.favorited" id="btn-unfavorite" @click="removeFromFavorites(lot.id, 'lot')"
                      data-toggle="modal"
                      data-target="#favoritesModal"
                      type="button" class="btn btn-fav" v-bind:title="$t('categories.titleUnfav')"
                      data-placement="left" style="margin-right: 5px;">
                <svg enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m471.382812 44.578125c-26.503906-28.746094-62.871093-44.578125-102.410156-44.578125-29.554687 0-56.621094 9.34375-80.449218 27.769531-12.023438 9.300781-22.917969 20.679688-32.523438 33.960938-9.601562-13.277344-20.5-24.660157-32.527344-33.960938-23.824218-18.425781-50.890625-27.769531-80.445312-27.769531-39.539063 0-75.910156 15.832031-102.414063 44.578125-26.1875 28.410156-40.613281 67.222656-40.613281 109.292969 0 43.300781 16.136719 82.9375 50.78125 124.742187 30.992188 37.394531 75.535156 75.355469 127.117188 119.3125 17.613281 15.011719 37.578124 32.027344 58.308593 50.152344 5.476563 4.796875 12.503907 7.4375 19.792969 7.4375 7.285156 0 14.316406-2.640625 19.785156-7.429687 20.730469-18.128907 40.707032-35.152344 58.328125-50.171876 51.574219-43.949218 96.117188-81.90625 127.109375-119.304687 34.644532-41.800781 50.777344-81.4375 50.777344-124.742187 0-42.066407-14.425781-80.878907-40.617188-109.289063zm0 0"/>
                </svg>
              </button>

              <button v-if="!lot.favorited" id="btn-favorite" @click="addToFavorites(lot.id, 'lot')"
                      type="button"
                      data-placement="left"
                      class="btn btn-fav" v-bind:title="$t('categories.titleFav')"
                      style="margin-right: 5px;">
                <svg enable-background="new 0 0 512 512" height="20" viewBox="0 0 512 512"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="m256 455.515625c-7.289062 0-14.316406-2.640625-19.792969-7.4375-20.683593-18.085937-40.625-35.082031-58.21875-50.074219l-.089843-.078125c-51.582032-43.957031-96.125-81.917969-127.117188-119.3125-34.644531-41.804687-50.78125-81.441406-50.78125-124.742187 0-42.070313 14.425781-80.882813 40.617188-109.292969 26.503906-28.746094 62.871093-44.578125 102.414062-44.578125 29.554688 0 56.621094 9.34375 80.445312 27.769531 12.023438 9.300781 22.921876 20.683594 32.523438 33.960938 9.605469-13.277344 20.5-24.660157 32.527344-33.960938 23.824218-18.425781 50.890625-27.769531 80.445312-27.769531 39.539063 0 75.910156 15.832031 102.414063 44.578125 26.191406 28.410156 40.613281 67.222656 40.613281 109.292969 0 43.300781-16.132812 82.9375-50.777344 124.738281-30.992187 37.398437-75.53125 75.355469-127.105468 119.308594-17.625 15.015625-37.597657 32.039062-58.328126 50.167969-5.472656 4.789062-12.503906 7.429687-19.789062 7.429687zm-112.96875-425.523437c-31.066406 0-59.605469 12.398437-80.367188 34.914062-21.070312 22.855469-32.675781 54.449219-32.675781 88.964844 0 36.417968 13.535157 68.988281 43.882813 105.605468 29.332031 35.394532 72.960937 72.574219 123.476562 115.625l.09375.078126c17.660156 15.050781 37.679688 32.113281 58.515625 50.332031 20.960938-18.253907 41.011719-35.34375 58.707031-50.417969 50.511719-43.050781 94.136719-80.222656 123.46875-115.617188 30.34375-36.617187 43.878907-69.1875 43.878907-105.605468 0-34.515625-11.605469-66.109375-32.675781-88.964844-20.757813-22.515625-49.300782-34.914062-80.363282-34.914062-22.757812 0-43.652344 7.234374-62.101562 21.5-16.441406 12.71875-27.894532 28.796874-34.609375 40.046874-3.453125 5.785157-9.53125 9.238282-16.261719 9.238282s-12.808594-3.453125-16.261719-9.238282c-6.710937-11.25-18.164062-27.328124-34.609375-40.046874-18.449218-14.265626-39.34375-21.5-62.097656-21.5zm0 0"/>
                </svg>
              </button>
              <dropdown placement="bottom-center" :overlay="false">
                <div class="flex items-center cursor-pointer select-none group">
                  <div
                      class="text-grey-700 group-hover:text-gray-900 focus:text-gray-900 mr-1 whitespace-no-wrap transition ease-in-out duration-150">
                    <svg class="text-gray-700 hover:text-gray-900 fill-current w-5 h-5"
                         enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                         xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                            d="m407 302c-35.66 0-67.219 17.873-86.205 45.127l-116.132-58.066c3.458-10.4 5.337-21.515 5.337-33.061s-1.879-22.661-5.337-33.061l116.132-58.066c18.986 27.254 50.545 45.127 86.205 45.127 57.897 0 105-47.103 105-105s-47.103-105-105-105-105 47.103-105 105c0 11.546 1.879 22.661 5.337 33.061l-116.132 58.066c-18.986-27.254-50.545-45.127-86.205-45.127-57.897 0-105 47.103-105 105s47.103 105 105 105c35.66 0 67.219-17.873 86.205-45.127l116.132 58.066c-3.458 10.4-5.337 21.515-5.337 33.061 0 57.897 47.103 105 105 105s105-47.103 105-105-47.103-105-105-105zm0-272c41.355 0 75 33.645 75 75s-33.645 75-75 75-75-33.645-75-75 33.645-75 75-75zm-302 301c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm302 151c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z"></path>
                      </g>
                    </svg>
                  </div>
                </div>
                <div slot="dropdown" class="mt-2 shadow-xl bg-white text-sm">
                  <a :href="lot.shop_facebook_share_link"
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="fill-current w-4 h-4 text-sm" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
                         width="24px" height="24px" viewBox="0 0 90 90" xml:space="preserve">
                          <path
                              d="M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998 C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41  h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z"
                              data-original="#000000" class="active-path"/>
                        </svg>
                    <span class="pl-2">Facebook</span>
                  </a>
                  <a :href='"mailto: ?subject=Recomand Dependent de Artă - " + lot.title + "&body=Recomand Dependent de Artă - " + lot.title + "%0D%0A" + currentPage()'
                     class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    <span class="pl-2">Email</span>
                  </a>
                  <div @click="copyToClipboard(lot)"
                       class="flex flex-row items-center px-3 py-2 text-gray-900 hover:bg-gray-800 hover:text-white transition ease-in-out duration-150">
                    <svg class="w-4 h-4" fill="none" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                          d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
                    </svg>
                    <span class="pl-2">{{ $t('misc.copy_link') }}</span>
                  </div>
                </div>
              </dropdown>
            </div>
            <img
                v-if="((lot.auction_id == 860 && (lot.number  == 7 || lot.number  == 8 || lot.number  == 11 || lot.number  == 13 || lot.number  == 100 || lot.number  == 123 || lot.number  == 133 || lot.number  == 141 || lot.number  == 150 || lot.number  == 153 || lot.number  == 156 || lot.number  == 160 || lot.number  == 161 || lot.number  == 171 || lot.number  == 177 || lot.number  == 179 || lot.number  == 180 || lot.number  == 192 || lot.number  == 55 || lot.number  == 57)) || (lot.auction_id == 853 && (lot.number == 105 || lot.number == 153)))"
                src="/assets/img/Inima_caritabile.png"
                width="30px" height="30px"
            />
          </div>
          <div :id="'iziToast-wrapper_cart_' + lot.id"></div>
        </div>
      </div>
    </div>
    <div v-else class="my-12 flex justify-center text-gray-800 text-xl">
      {{ $t('misc.no_lots') }}
    </div>
    <div v-if="needsPagination()" class="flex justify-center mb-8">
      <pagination :links="lots.links"/>
    </div>
  </div>
</template>
<style>
.addToCartDisabled {
  background: #48bb78 !important;
  cursor: pointer !important;
  display: block;
}
</style>
<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SelectInput from '@/Shared/SelectInput'
import Dropdown from '@/Shared/Dropdown'
import axios from 'axios'
import Router from "vue-router";
//import Inertia from '@inertiajs/inertia'
import VueRangeSlider from 'vue-range-component'
import 'vue-range-component/dist/vue-range-slider.css'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo() {
    return {
      title: this.category.name,
      meta: [
        {
          name: 'robots',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {
          name: 'googlebot',
          content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
        },
        {name: 'title', content: this.category.name},
        {name: 'description', content: this.category.name},
        {name: 'keywords', content: this.category.name},
        // Facebook
        {name: 'og:title', property: 'og:title', content: this.category.name},
        {name: 'og:description', property: 'og:description', content: 'Placeholder'},
        {name: 'og:image', property: 'og:image', content: 'Placeholder Image Link'},
        {name: 'og:url', property: 'og:url', content: window.location.href},
        {name: 'og:type', property: 'og:type', content: 'website'},
      ]
    }
  },
  layout: Layout,
  // inertia: Inertia,
  props: {
    category: Object,
    lots: Object,
    perPage: String,
    min: Number,
    max: Number
  },
  components: {
    Layout, Pagination, SelectInput, Dropdown, Router, VueRangeSlider, TextInput
  },
  data() {
    return {
      range: 1000,
      rangeValue: [this.min, this.max],
      rangeMin: this.min,
      rangeMax: this.max,
      lotFilter: 1,
      scrollPosition: null,
      showCart25: 0,
      showCart30: 0,
    }
  },
  computed: {
    filteredLots() {
      if (this.lotFilter == 2) {
        return [...this.lots.data].sort((a, b) => (a.shop_price > b.shop_price ? -1 : 1))
      }

      if (this.lotFilter == 3) {
        return [...this.lots.data].sort((a, b) => (a.shop_price > b.shop_price ? 1 : -1))
      }

      return [...this.lots.data]
    }
  },
  methods: {
    askDetailsDiscount: function (id) {
      if (this.logged_in != null) {
        event.preventDefault();
        axios({
          method: "post",
          url: "/api/ask-details",
          data: {"type": "askDetailsDDADiscount", "params": {"lot": id, "user": this.logged_in}},
          config: {
            headers: {
              "Content-Type": "application/json",
            }
          }
        }).then((response) => {
          if (response.status == 200) {
            let msg = 'Echipa DDA a fost anuntata, veti fi contactat in cel mai scurt timp!';
            this.$iziToast.show({
              message: msg,
              color: 'green',
              position: 'topCenter',
              progressBar: false,
              timeout: 50000,
              displayMode: 'once'
            });
          } else {
            let msg = 'Mesajul nu a putut fi transmis! Va rugam reincercati.';
            this.$iziToast.show({
              message: msg,
              color: 'red',
              position: 'topCenter',
              progressBar: false,
              timeout: 50000,
              displayMode: 'once'
            });
          }
        }).catch(function (error) {
          let msg = 'Mesajul nu a putut fi transmis! Va rugam reincercati.';
          this.$iziToast.show({
            message: msg,
            color: 'red',
            position: 'topCenter',
            progressBar: false,
            timeout: 50000,
            displayMode: 'once'
          });
        });
      } else {
        window.location.href = "mailto:office@dependentdearta.ro?subject=Informatii despre lot id: " + this.lot.id + "&body=Buna ziua, " + "%0D%0A" + "%0D%0A" +
            "As dori să îmi furnizați informații despre reducerea suplimentară aferentă acestui produs." + "%0D%0A" +
            "Link catre produs: " + window.location.href + "%0D%0A" + "%0D%0A" +
            "Va multumesc,"
      }
    },
    makeLotTitle: function (lot, short = false) {
      let newArguments = [];
      let title = lot.title;
      if (short) {
        title = lot.shortened_title;
      }

      if (lot.heritage === 1) {
        newArguments.push('C');
      }
      if (lot.heritage === 2) {
        newArguments.push('F');
      }
      if (lot.heritage === 3) {
        newArguments.push('T');
      }
      if (lot.heritage === 4) {
        newArguments.push('IC');
      }
      if (lot.heritage === 5) {
        newArguments.push('IT');
      }
      if (lot.archive_preemption === 1) {
        newArguments.push('A');
      }

      if (newArguments.length > 0) {
        return '<sup>' + newArguments.join(", ") + '</sup> ' + title;
      } else {
        return title;
      }
    },
    getSubcategories: function () {
      this.$inertia.visit(route('shop.category.view', this.category.slug), {
        data: {
          giftSubcategory: this.$refs['gift-categories'].selected
        },
        replace: false,
        preserveState: true,
        preserveScroll: true,
      })
    },
    addToFavorites: function (id, type) {
      document.activeElement.blur();

      if (this.$page.auth.user != null) {
        if (this.$page.auth.user.id > 0) {
          axios({
            method: "post",
            url: "/api/add-favorites",
            data: {"favorites": [{"type": type, "id": id}]},
            config: {
              headers: {
                "Content-Type": "application/json"
              }
            }
          }).then((response) => {
            this.$inertia.visit(route('shop.category.view', this.category.slug), {
              replace: false,
              preserveState: true,
              preserveScroll: true,
            });
            var msg = window.location.pathname.split('/')[1] == 'ro' ? 'Opera a fost adăugată la Favorite!' : 'Artwork added to Favorites!';
            this.$iziToast.show({
              message: msg,
              color: 'green',
              position: 'bottomRight',
              progressBar: true,
              timeout: 5000000000000000,
              displayMode: 'replace'//once
            });
          }).catch(function (error) {
            if (error.response.status === 401) {
              this.$iziToast.show({
                message: error,
                color: 'red',
                position: 'bottomRight',
                progressBar: true,
                timeout: 5000000000000000,
                displayMode: 'replace'//once
              });
            } else {
              location.reload();
            }
          });
        }
      } else {
        let localFavorites = localStorage.getItem('localFavorites');
        localFavorites = localFavorites ? localFavorites.split(',') : [];
        localFavorites.push(JSON.stringify({
          type: 'Lot',
          fav_id: id,
          whereFrom: location.href
        }));

        localStorage.setItem('localFavorites', localFavorites);
        window.location.replace('/ro/autentificare');
      }
      event.preventDefault();
    }
    ,
    removeFromFavorites: function (id, type) {
      document.activeElement.blur();
      axios({
        method: "post",
        url: "/api/remove-favorites",
        data: {"favorites": [{"type": type, "id": id}]},
        config: {
          headers: {
            "Content-Type": "application/json"
          }
        }
      }).then((response) => { //succes
        var msg = window.location.pathname.split('/')[1] == 'ro' ? 'Opera a fost eliminată de la Favorite!' : 'Artwork removed from Favorites!';
        this.$inertia.visit(route('shop.category.view', this.category.slug), {
          replace: false,
          preserveState: true,
          preserveScroll: true,
        });
        this.$iziToast.show({
          message: msg,
          color: 'red',
          position: 'bottomRight',
          progressBar: true,
          timeout: 5000000000000000,
          displayMode: 'replace'//once
        });
      }).catch(function (error) {
        this.$iziToast.show({
          message: error,
          color: 'red',
          position: 'bottomRight',
          progressBar: true,
          timeout: 5000000000000000,
          displayMode: 'replace'//once
        });
      });
    }
    ,
    inArray(needle) {
      var haystack = Object.keys(this.$page.cart.items);
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    }
    ,
    addToCart(id) {
      let locale = window.location.pathname.split('/')[1];
      axios({
        method: "post",
        url: '/' + locale + '/cart/add/' + id
      }).then((response) => {
        if (response.data.status == 'success') {
          let carts = document.querySelectorAll('sup.cart_quantity');
          for (let i = 0, len = carts.length; i < len; ++i) {
            let cart = carts[i];
            cart.innerHTML = response.data.quantity;
          }
          if (locale != 'ro') {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/en/cart' style='background: #48bb78;' class=\"btn-gray a10-btn-padding addToCartDisabled\">Product added!<br/>Go to your cart!</a>";
          } else {
            document.getElementById("addToCart_wrapper_" + id).innerHTML = "<a href='/ro/cart' style='background: #48bb78;' class=\"btn-gray a10-btn-padding addToCartDisabled\">Produs adăugat!<br/>Vezi coșul!</a>";
          }
        } else {
          this.$iziToast.show({
            message: response.data.message,
            color: 'red',
            position: null,
            target: "#iziToast-wrapper_cart_" + id,
            progressBar: false,
            timeout: 500000,
            displayMode: 'replace'//once
          });
        }
      });
    }
    ,
    checkCart() {
      axios({
        method: "get",
        url: '/ro/cart/checkContent'
      }).then((response) => {
        if (response.data.status == 'success') {
          if (response.data.interval == 25 && this.showCart25 == 0) {
            this.$iziToast.show({
              message: response.data.message,
              color: 'red',
              position: 'topCenter',
            });
            this.showCart25 = 1;
          } else if (response.data.interval == 30 && this.showCart30 == 0) {
            this.$iziToast.show({
              message: response.data.message,
              color: 'red',
              position: 'topCenter',
            });
            this.showCart30 = 1;
          }
        }
      });
    }
    ,
    changeLotsPerPage() {
      this.$inertia.visit(route('shop.category.view', this.category.slug), {
        data: {
          lotsPerPage: this.$refs['lots-per-page'].selected,
          giftSubcategory: this.$refs['gift-categories'] ? this.$refs['gift-categories'].selected : null
        },
        replace: false,
        preserveState: true,
        preserveScroll: true,
      })
    }
    ,
    filterByPrice() {
      this.$inertia.visit(route('shop.category.view', this.category.slug), {
        data: {
          priceRange: [this.rangeMin, this.rangeMax],
          giftSubcategory: this.$refs['gift-categories'] ? this.$refs['gift-categories'].selected : null
        },
        replace: false,
        preserveState: true,
        preserveScroll: true,
      })
    }
    ,
    needsPagination() {
      const needsPagination = this.lots.links.filter(link => {
        return link.label == '2'
      })

      if (needsPagination.length < 1 || this.perPage == 'all') {
        return false
      }

      return true
    }
    ,
    currentPage() {
      return window.location.href
    }
    ,
    copyToClipboard(lot) {
      return window.navigator.clipboard.writeText(this.route('shop.lot.view', lot.slug));
    }
    ,
    updateScroll() {
      this.scrollPosition = window.scrollY
    }
  }
  ,
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  }
  ,
  created() {
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('priceRange[0]') && urlParams.get('priceRange[1]')){
      this.rangeMin = urlParams.get('priceRange[0]');
      this.rangeMax = urlParams.get('priceRange[1]');
    }
    VueRangeSlider.methods.handleKeyup = () => console.log;
    VueRangeSlider.methods.handleKeydown = () => console.log;
    this.bgStyle = {
      backgroundColor: '#fff',
      boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
    };
    this.tooltipStyle = {
      backgroundColor: '#343a40',
      borderColor: '#343a40'
    };
    this.processStyle = {
      backgroundColor: '#343a40'
    };
    // document.querySelector('.v-dropdown-menu__container').style.display = "none";
    this.interval = setInterval(() => this.checkCart(), 60000);
  }
  ,
  beforeDestroy() {
    clearInterval(this.interval)
  }
  ,
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  }
}
</script>
